<template>
	<div class="classificacao-semed-base">
		<div class="row">
			<div class="col-sm-4 col-md-3">
				<ul class="classificacao-semed-base__nav">
					<li
						v-for="c in cargos"
						:key="c.slug"
						:class="{ active: $route.params.cargo === c.slug }"
					>
						<router-link :to="'/servicos/classificacao-semed/' + c.slug">{{ c.titulo }}</router-link>
					</li>
				</ul>
			</div>
			<div class="col-sm-8 col-md-9">
				<router-view />
			</div>
		</div>
	</div>
</template>

<script>
import cargos from '../cargos'

export default {
	name: 'ClassificacaoSemedBase',
	data() {
		return {
			cargos,
		}
	},
}
</script>

<style lang="scss" scoped>
.classificacao-semed-base {
	&__nav {
		list-style: none;
		padding: 0;
		margin: 0 0 20px;
		background: #3b4b95;
		border-radius: 0;
		li {
			border-top: 1px solid rgba(255, 255, 255, 0.35);
			&:first-child {
				border-top: none;
			}
			a {
				display: block;
				padding: 14px 12px;
				color: #fff;
				font-size: 13px;
				line-height: 1.35;
				text-decoration: none;
				&:hover {
					background: rgba(255, 255, 255, 0.08);
				}
			}
			&.active a {
				background: #8ba4c7;
				color: #fff;
			}
		}
	}
}
</style>
